import { startCase } from 'lodash';

import { Month } from '@occc/graphql';

export const MONTH_SEQUENCE: Month[] = [
  Month.January,
  Month.February,
  Month.March,
  Month.April,
  Month.May,
  Month.June,
  Month.July,
  Month.August,
  Month.September,
  Month.October,
  Month.November,
  Month.December,
];

export const getMonthLabel = (month: Month) => startCase(month.toLowerCase());

export const monthOptions = MONTH_SEQUENCE.map((month) => ({
  value: month,
  label: getMonthLabel(month),
}));
